import React from "react";
import PublicLayout from "../components/layout/PublicLayout";

function ContactSupport() {
  return (
    <PublicLayout>
      <div
        className="prose max-w-none items-center justify-center"
        style={{
          display: "grid",
          justifyContent: "center",
          justifyItems: "center",
          alignItems: "center",
        }}
      >
        <h1>Contact Support</h1>
        <p>
          If you have any questions or need assistance, please contact our
          support team.
        </p>
        {/* <form className="mt-6 space-y-4 max-w-md">
          <div>
            <label
              htmlFor="name"
              className="block text-sm font-medium text-gray-700"
            >
              Name
            </label>
            <input
              type="text"
              id="name"
              name="name"
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2 focus:ring-primary focus:border-primary"
              placeholder="Your name"
            />
          </div>
          <div>
            <label
              htmlFor="email"
              className="block text-sm font-medium text-gray-700"
            >
              Email
            </label>
            <input
              type="email"
              id="email"
              name="email"
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2 focus:ring-primary focus:border-primary"
              placeholder="you@example.com"
            />
          </div>
          <div>
            <label
              htmlFor="message"
              className="block text-sm font-medium text-gray-700"
            >
              Message
            </label>
            <textarea
              id="message"
              name="message"
              rows="4"
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2 focus:ring-primary focus:border-primary"
              placeholder="Your message"
            ></textarea>
          </div>
          <button
            type="submit"
            className="bg-primary text-white px-4 py-2 rounded hover:bg-primary-700 transition-colors"
            style={{ width: "-webkit-fill-available" }}
          >
            Send Message
          </button>
        </form> */}
      </div>
    </PublicLayout>
  );
}

export default ContactSupport;
